var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLuggageHandbag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.506,
    height: 28.37,
    viewBox: "0 0 24.506 28.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_664",
    "data-name": "Pfad 664",
    d: "M393.046,48.259h-5.361c-.2-3.9-.539-6.114-.539-6.114-1.1-5.323-7.08-3.616-7.08-3.616-4.543,1.217-4.8,8.724-4.82,9.73h-5.5a.6.6,0,0,0-.6.6v16.27a1.511,1.511,0,0,0,1.506,1.506h21.493a1.511,1.511,0,0,0,1.507-1.506V48.862A.605.605,0,0,0,393.046,48.259Zm-15.09-6.114c.552-3.214,5.072-2.812,5.072-2.812,4.017.1,2.963,4.017,2.963,4.67a33.667,33.667,0,0,1-1.248,4.256H377.4A28.416,28.416,0,0,1,377.956,42.145Zm8.788,15.781a.831.831,0,0,1-.828.828h-9.039a.831.831,0,0,1-.829-.828v-4.9a.831.831,0,0,1,.829-.828h9.039a.831.831,0,0,1,.828.828Z",
    transform: "translate(-369.143 -38.268)",
    fill: "#183f75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuggageHandbag);
export default __webpack_public_path__ + "static/media/luggage_handbag.7834d52ac3863eb0919360caa65d5866.svg";
export { ForwardRef as ReactComponent };